import { trackAnalyticsEvent } from '../track'

/** Impression for the market hero's Trusted-by row, fired once per market on first visibility. */
export function trackMarketTrustedByViewed(params: {
  marketId: string
  chainId: number
  curatorCount: number
}) {
  trackAnalyticsEvent('market_trusted_by_viewed', {
    market_id: params.marketId,
    chain_id: params.chainId,
    curator_count: params.curatorCount
  })
}

/** Click on a curator name in the Trusted-by row, an entry point from a market to a curator page. */
export function trackMarketTrustedByCuratorClicked(params: {
  marketId: string
  chainId: number
  curatorId: string
  curatorName: string
}) {
  trackAnalyticsEvent('market_trusted_by_curator_clicked', {
    market_id: params.marketId,
    chain_id: params.chainId,
    curator_id: params.curatorId,
    curator_name: params.curatorName
  })
}
